/**
 * 接入百度统计
 */

const BAIDU_URL = '//hm.baidu.com/h.js?3a3829a8eae7d791fc22e7eb4990aea5' // 随手记百度统计地址

// 百度统计接入
const insert = () => {
  const baidu = document.createElement('script')
  baidu.type = 'text/javascript'
  baidu.async = true
  baidu.src = BAIDU_URL
  document.body.appendChild(baidu)
}

export default () => {
  setTimeout(insert, 0) // 避免加载阻断其他JS不执行
}


// WEBPACK FOOTER //
// ./node_modules/@common/collect/src/lib/baidu.js